import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-view-button',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './view-button.component.html',
  styleUrl: './view-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewButtonComponent {
  @Output() readonly onViewClicked = new EventEmitter<void>();

  onSubmit(): void {
    this.onViewClicked.emit();
  }
}
